import FormElementTypes from '../../FormElementTypes'
import Interpretations  from '../../interpretations'

export default new class FormElementButtonsHelper {

  /**
   *
   * @param element
   * @returns {[]}
   */
  getButtonsDef (element) {
    const output = []

    if (!element.fields) {
      return []
    }

    element.fields.forEach((item) => {
      if (item.FieldType === FormElementTypes.enuFormAction) {
        output.push(item)
      }
    })

    return output
  }
}
